module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row full-height"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-12 col-xl-12 full-height"
  }, [(!_vm.activeItem) ? _c('div', {
    staticClass: "image-wrapper"
  }, [_c('div', {
    staticClass: "active-empty-state"
  }, [_c('img', {
    attrs: {
      "src": _vm.emptyStateSrc
    }
  }), _vm._v("\n        Please select an element to edit\n      ")])]) : _c('drag-item-edit', {
    attrs: {
      "limitEditing": _vm.limitEditing,
      "editorName": _vm.editorName
    },
    on: {
      "delete": _vm.deleteElement,
      "input": _vm.editElement
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-304c45d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/DragActiveItemContainer.vue
// module id = 1857
// module chunks = 0